module.exports = __webpack_public_path__ + "static/img/topBgc.c0341d44.png";